import {Title} from "#app/interface/cabinet/header/Dropdown/styles";
import Dropdown from "#app/interface/cabinet/header/Dropdown/Dropdown";
import React from "react";
import {routes} from "#app/constants/routes";

const PlanDropdown = ({ i18n, data, handleMenu, url }) => {
  const condition3 = routes.planValidPaths.includes(url);

  const menuLinks = [
    { id: 'plan-menu-0', link: routes.plan.plan, text: i18n.menu.dashboard },
    { id: 'plan-menu-1', link: routes.plan.salaryPlan, text: i18n.menu.plan },
    { id: 'plan-menu-2', link: routes.plan.goals, text: i18n.menu.goals },
    { id: 'plan-menu-3', link: routes.plan.insurances, text: 'Страхование' }
  ];

  return (
    <Dropdown
      id="dropdown-plan"
      width="auto"
      containerId="dropdown-plan-container"
      links={menuLinks}
    >
      <Title
        id="accounting-tab-3"
        className={condition3 ? 'active' : ''}
        onClick={(e) => handleMenu(e, routes.plan.plan)}
      >
        {i18n.menu.planing}
      </Title>
    </Dropdown>
  );
};

export default PlanDropdown;